import List from '../modules/quote_table/list'

declare var Swiper;

var data = {
    refresh_time: 10,
    quotaConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get'
    },
    init:function(){
        let self = this
        self.getData(self.gethushenzhishu(), self.bindSwiperData)
        self.getData(self.gethushengangtong(),self.bindHushengangtong)
        self.makeList1("b:BK0707",'hsgt-hgt')
        self.makeList2("b:BK0804",'hsgt-sgt')
        self.makeList3("b:DLMK0144",'hsgt-ggth')
        self.makeList4("b:DLMK0146",'hsgt-ggts')
        self.makeList5()
        // 沪股通
        $("#hgt-stock-list").on('click',function(){
            self.makeList1("b:BK0707",'hsgt-hgt')
            $('#hsgt-hgt').css('display','block')
            $('#hsgt-hgt-etf').css('display','none')
        })
        $("#hgt-fund-list").on('click',function(){
            self.makeList1("b:MK0839",'hsgt-hgt-etf')
            $('#hsgt-hgt-etf').css('display','block')
            $('#hsgt-hgt').css('display','none')  
        })
        // 深股通
        $("#sgt-stock-list").on('click',function(){
            self.makeList2("b:BK0804",'hsgt-sgt')
            $('#hsgt-sgt').css('display','block')
            $('#hsgt-sgt-etf').css('display','none')
        })
        $("#sgt-fund-list").on('click',function(){
            self.makeList2("b:MK0840",'hsgt-sgt-etf')  
            $('#hsgt-sgt-etf').css('display','block')
            $('#hsgt-sgt').css('display','none')  
        })
        // 港股通 - 沪
        $("#ggth-stock-list").on('click',function(){
            self.makeList3("b:DLMK0144",'hsgt-ggth')
            $('#hsgt-ggth').css('display','block')
            $('#hsgt-ggth-etf').css('display','none')
        })
        $("#ggth-fund-list").on('click',function(){
            self.makeList3("b:MK0838",'hsgt-ggth-etf')  
            $('#hsgt-ggth-etf').css('display','block')
            $('#hsgt-ggth').css('display','none')  
        })
        // 港股通 - 深
        $("#ggts-stock-list").on('click',function(){
            self.makeList4("b:DLMK0146",'hsgt-ggts')
            $('#hsgt-ggts').css('display','block')
            $('#hsgt-ggts-etf').css('display','none')
        })
        $("#ggts-fund-list").on('click',function(){
            self.makeList4("b:MK0837",'hsgt-ggts-etf')  
            $('#hsgt-ggts-etf').css('display','block')
            $('#hsgt-ggts').css('display','none')  
        })
        if (self.refresh_time > 0) {
            clearInterval(self.timer)
            self.timer = setInterval(() => {
                self.refresh()
            }, self.refresh_time * 1000);
        }
    },
    // 沪深指数 Ajax 请求地址
    gethushenzhishu: function () {
        let self = this
        let ids = "1.000001,0.399001,100.HSI,1.000010,1.000009,1.000688,1.000016,1.000905,0.399015,124.HSLI,124.HSMI,124.HSSI";
        let url = self.quotaConfig.host + self.quotaConfig.unpPath
            + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids
            + "&ut=" + self.quotaConfig.token + "&forcect=1";
        return url
    },
    //获取沪深港通当日剩余额度
    gethushengangtong:function(){
        return `https://push2.eastmoney.com/api/qt/kamt/get?fltt=2&invt=2&fields1=f1,f2,f3,f4&fields2=f51,f53,f65&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`
    },
    // Ajax 请求
    getData: function (url, callback) {
        let self = this
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
                callback(data, self)
            }
        })
    },
    // 给 Swiper 绑定数据
    bindSwiperData: function (data, self) {
        if (data.rc == 0) {
            let _class = ''
            let _siwper_html = ''
            data.data.diff.forEach((item, index) => {
                // if(item.f14 == '恒生综合大型股指数'){
                //     item.f14 = '恒生大型'
                // }else if(item.f14 == '恒生综合中型股指数'){
                //     item.f14 = '恒生中型'
                // }else if(item.f14 == '恒生综合小型股指数'){
                //     item.f14 = '恒生小型'
                // }
                if (index == 0) {
                    _class = 'swiper-slide swiper-slide-active'
                } else if (index == 1) {
                    _class = 'swiper-slide swiper-slide-next'
                } else {
                    _class = 'swiper-slide'
                }
                _siwper_html += `<div class="${_class}">
                                <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p style="${item.f14.length > 6 ? 'font-size:1.3rem;' : ''}">${item.f14}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                                        <span>${self.numberFix(item.f4,2)}</span>
                                        <span>${self.dataProcess(item.f3,2,'%')}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
            })
            $('#hushenzhishu').html(_siwper_html)
            new Swiper('.hqq-swiper', {
                direction: 'horizontal',
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.go-nuxt',
                    prevEl: '.go-pre',
                }
            })
        }
    },
    // Swiper 数据刷新
    refreshSwiperData: function (data,self) {
        let _dom = $('#hushenzhishu').find('.swiper-slide')
        if (data.rc == 0) {
            data.data.diff.forEach((item, index) => {
                // if(item.f14 == '恒生综合大型股指数'){
                //     item.f14 = '恒生大型'
                // }else if(item.f14 == '恒生综合中型股指数'){
                //     item.f14 = '恒生中型'
                // }else if(item.f14 == '恒生综合小型股指数'){
                //     item.f14 = '恒生小型'
                // }
                _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p style="${item.f14.length > 6 ? 'font-size:1.3rem;' : ''}">${item.f14}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                        <span>${self.numberFix(item.f4,2)}</span>
                        <span>${self.dataProcess(item.f3,2, '%')}</span>
                    </p>
                </a>
            </div>`
            })
        }
    },
    // 给沪深港通额度绑定数据
    bindHushengangtong:function(data,self){
        let html = `
            <ul>
                <li>
                    <p>沪股通</p>
                    <p>${self.gethushengutongAmt(data.data.hk2sh,self)}</p>
                </li>
                <li>
                    <p>港股通(沪)</p>
                    <p>${self.gethushengutongAmt(data.data.sh2hk,self)}</p>
                </li>
                <li>
                    <p>深股通</p>
                    <p>${self.gethushengutongAmt(data.data.hk2sz, self)}</p>
                </li>
                <li>
                    <p>港股通(深)</p>
                    <p>${self.gethushengutongAmt(data.data.sz2hk,self)}</p>
                </li>
            </ul>
        `
        $('#hsgt-drsyed').html(html)
    },
    makeList1:function(type,ele){
        let self = this
        let List1 = new List({
            ele:ele,
            api:`//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=${type}&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
            refresh: 10,
            html:function(data){
                let icon = ''
                if ((data.f13 == 1) && (data.f19 == 23)) {
                    icon = icon + "<span class='icon-kc' style='margin-left:.3rem'>科创</span>"
                }
                if (data.f148 & 64) {
                    icon = icon + "<span class='icon-rz' style='margin-left:.3rem'>融</span>"
                }
                return `
                <dd>
                    <a href="/quote/stock/${data.f13 == '128' ? '116' : data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}${icon}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f4,data.f1)}</div>
                    </a>
                </dd>
                `
            }
        })
        List1.init().then(function(){
            $("#hgt-stock-list").on('click',function(){
                self.toggleStyle('stock','hgt')
            })
            $("#hgt-fund-list").on('click',function(){
                self.toggleStyle('fund','hgt')
            })
        })
    },
    makeList2:function(type,ele){
        let self = this
        let List2 = new List({
            ele:ele,
            api:`//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=${type}&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
            refresh: 10,
            html:function(data){
                let icon = ''
                if ((data.f13 == 1) && (data.f19 == 23)) {
                    icon = icon + "<span class='icon-kc' style='margin-left:.3rem'>科创</span>"
                }
                if (data.f148 & 64) {
                    icon = icon + "<span class='icon-rz' style='margin-left:.3rem'>融</span>"
                }
                return `
                <dd>
                    <a href="/quote/stock/${data.f13 == '128' ? '116' : data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}${icon}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f4,data.f1)}</div>
                    </a>
                </dd>
                `
            }
        })
        List2.init().then(function(){
            $("#sgt-stock-list").on('click',function(){
                self.toggleStyle('stock','sgt')
            })
            $("#sgt-fund-list").on('click',function(){
                self.toggleStyle('fund','sgt')
            })
        })
    },
    makeList3:function(type,ele){
        let self = this
        let List3 = new List({
            ele:ele,
            api:`//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=${type}&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
            refresh: 10,
            html:function(data){
                let icon = ''
                if ((data.f13 == 1) && (data.f19 == 23)) {
                    icon = icon + "<span class='icon-kc' style='margin-left:.3rem'>科创</span>"
                }
                if (data.f148 & 64) {
                    icon = icon + "<span class='icon-rz' style='margin-left:.3rem'>融</span>"
                }
                return `
                <dd>
                    <a href="/quote/stock/${data.f13 == '128' ? '116' : data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}${icon}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f4,data.f1)}</div>
                    </a>
                </dd>
                `
            }
        })
        List3.init().then(function(){
            $("#ggth-stock-list").on('click',function(){
                self.toggleStyle('stock','ggth')
            })
            $("#ggth-fund-list").on('click',function(){
                self.toggleStyle('fund','ggth')
            })
        })
    },
    makeList4:function(type,ele){
        let self = this
        let List4 = new List({
            ele:ele,
            api:`//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148&pn=1&pz=10&fid=f3&po=1&fs=${type}&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1`,
            refresh: 10,
            html:function(data){
                let icon = ''
                if ((data.f13 == 1) && (data.f19 == 23)) {
                    icon = icon + "<span class='icon-kc' style='margin-left:.3rem'>科创</span>"
                }
                if (data.f148 & 64) {
                    icon = icon + "<span class='icon-rz' style='margin-left:.3rem'>融</span>"
                }
                return `
                <dd>
                    <a href="/quote/stock/${data.f13 == '128' ? '116' : data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                            <p>${data.f12}${icon}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,2,'%')}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f4,data.f1)}</div>
                    </a>
                </dd>
                `
            }
        })
        List4.init().then(function(){
            $("#ggts-stock-list").on('click',function(){
                self.toggleStyle('stock','ggts')
            })
            $("#ggts-fund-list").on('click',function(){
                self.toggleStyle('fund','ggts')
            })
        })
    },
    makeList5:function(){
        let self = this
        let List5 = new List({
            ele:'hsgt-ah',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14,f19,f148,f152,f186,f187,f188,f189,f190&pn=1&pz=10&fid=f188&po=1&fs=b:DLMK0101&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 10,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13 == '128' ? '116' : data.f13}.${data.f12}.html">
                        <div>
                            <p style=${data.f14.length>8?'font-size:1.3rem':''}>${data.f14}</p>
                        </div>
                        <div>
                            <p class=${data.f187 > 0 ? 'shares-rise' : (data.f187 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f186,data.f190)}</p>
                            <p class=${data.f187 > 0 ? 'shares-rise' : (data.f187 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f187,data.f152,'%')}</p>
                        </div>
                        <div>
                            <p class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,data.f1)}</p>
                            <p class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,data.f152,'%')}</p>
                        </div>
                        <div class=${data.f188 > 0 ? 'shares-rise' : (data.f188 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f188,data.f152,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List5.init()
    },
    refresh: function () {
        let self = this
        let url = self.gethushenzhishu()
        self.getData(url, self.refreshSwiperData)
        self.getData(self.gethushengangtong(),self.bindHushengangtong)
    },
    gethushengutongAmt : function (data, self) {
      if(data.status == 4) {
        return "休市"
      } else {
        // 获取沪深股通额度
        if (data.amtStatus == 1) {
          return '额度充足'
        } else if ( data.amtStatus == 2 ) {
            return self.conversion(data.dayAmtRemain*10000,false,true)
        } else {
            return '额度用完'
        }
      }
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
            if (num < 0) {
                numSign = '-'
            } else if (num == 0) {
                numSign = ''
            } else {
                numSign = '+'
            }
        } else {
            numSign = ''
        }
        if (Math.abs(num) == 0) {
            return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
            return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
            return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
            return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
            return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2)
            }
        } else if (Math.abs(num) >= 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 2)
            }
        } else {
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
            return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
            return f
        } else {
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + n) {
                s += '0';
            }
            return s;
        }
    },
    dataProcess(data,num,symbol) {
        let self = this
        if (data == undefined || data == null || data == '-') {
            return '-'
        } else {
            return self.numberFix(data, num) + symbol
        }
    },
    toggleStyle(type,id){
        if(type == 'stock'){
            $(`#${id}-stock-list`).removeClass("hsgt-tab-item")
            $(`#${id}-stock-list`).addClass("hsgt-tab-item-active")
            $(`#${id}-fund-list`).removeClass("hsgt-tab-item-active")
            $(`#${id}-fund-list`).addClass("hsgt-tab-item")
        }else{
            $(`#${id}-stock-list`).removeClass("hsgt-tab-item-active")
            $(`#${id}-stock-list`).addClass("hsgt-tab-item")
            $(`#${id}-fund-list`).addClass("hsgt-tab-item-active")
            $(`#${id}-fund-list`).removeClass("hsgt-tab-item")
        }
    }
}

data.init()